import type { HeaderSlotName } from '../model/types';
import { useHeaderFilters } from '../model/use-header-filters';

interface HeaderSlotProps {
  name: HeaderSlotName;
}

/**
 * Render target for content the active page registered via `useHeaderSlot`.
 * Renders nothing when the current route registered no content for this slot.
 */
export function HeaderSlot({ name }: HeaderSlotProps) {
  const { slots } = useHeaderFilters();

  return <>{slots[name] ?? null}</>;
}
